import React from 'react';
import { Bar } from 'react-chartjs-2';


function GroupedBar({ labels, valuesActiveUsers, valuesActiveUsersOneYearBack, setIndex }) {

  //Chart data
  const data = {
    labels: labels,
    datasets: [
      {
        label: "Last year",
        data: valuesActiveUsersOneYearBack,
        backgroundColor: "#FF9900",
        borderColor: "#FF9900",
        borderWidth: 1,
        stack: 'Stack 0',
      },
      {
        label: "Current year",
        data: valuesActiveUsers,
        backgroundColor: "#232b41",
        borderColor: "#232b41",
        borderWidth: 1,
        stack: 'Stack 1',
      },
    ],
  };
  
  //Chart options
  const options = {
      onClick: function(evt, element) {
        if(element.length > 0 && element[0].datasetIndex === 1) {
          
          setIndex(element[0].index)

        }
      },
      maintainAspectRatio: false,
      scales: {
          y: {
              ticks: {
                  beginAtZero: true,
                  
                   callback: function(value, index, values) {
                      return `${value} st`;
                  }
              },
          },
      }
 
  };
  
  return (
      <div>
          <Bar data={data} options={options} height={250}/>
      </div>
  )
}

export default GroupedBar

